/**
 * @prettier
 * @flow
 */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { translate } from 'src/utils/translate/translate';

export function NotFoundPage() {
    const classes = useStyles();
    return (
        <Grid container direction='row' justifyContent='center' alignItems='center' className={classes.container}>
            <Typography variant='h4' align='center' color='textSecondary'>
                {translate('Page Not Found')}
            </Typography>
        </Grid>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        height: 640,
    },
}));
